import {
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@mui/material';
import Box from '@mui/material/Box';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as CONST from '../../../../../constants/FieldsConst';
import { validMessage } from '../../../../../constants/ValidsFormConst';
import { dateformat } from '../../../../../helpers';
import { useNotification } from '../../../../../helpers/Notification';
import { LoadingWidget } from '../../../../../widgets';
import SelectFieldActividadesAcademicasComponent from '../../../../academico/actividades_academicas/components/SelectFieldActividadesAcademicas';
import { FechaField } from '../../../../accesos/components/FechaField';
import BotonComponent from '../../../../dashboard/components/BotonNuevo';
import { saveActividadesExtrasAction } from '../ActividadesExtrasAction';

const tipoActividadExtra = {
  RECUPERACION: 'RECUPERACION',
  REMEDIAL: 'REMEDIAL',
};

const FormActividadesExtras = ({ setOpenModalForm }) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const actividadesExtrasStore = Redux.useSelector(
    (state) => state.actividadesExtras,
  );
  const planEvaluacionStore = Redux.useSelector(
    (state) => state.planEvaluacion,
  );

  const activo = actividadesExtrasStore.activo;

  const initData = {
    tipo: '',
    idInstrumento: '',
    idPtevaInstrumento: '',
    fecha: actividadesExtrasStore.activo?.desde,
    ponderacion: '',
    desc: '',
    idEstatus: 1,
  };

  const [selectPevaInstrumento, setSelectPevaInstrumento] =
    React.useState(null);
  const [pevaInstrumentos, setPevaInstrumentos] = React.useState([]);
  const [instrumentos, setInstrumentos] = React.useState([]);

  const [data, setData] = React.useState(initData);
  const [dataError, setDataRequired] = React.useState({
    fechaInicio: false,
    ponderacion: false,
    tipo: false,
    idInstrumento: false,
  });
  const [loadingSave, setLoadingSave] = React.useState(false);

  React.useEffect(() => {
    if (planEvaluacionStore.activo) {
      planEvaluacionStore.activo.temas.forEach((tema) => {
        tema.evaluaciones.forEach((evaluacion) =>
          evaluacion.instrumentos.forEach((pevaInstrumento) => {
            setPevaInstrumentos((old) => [...old, pevaInstrumento]);
            setInstrumentos((old) => [...old, pevaInstrumento.instrumento]);
          }),
        );
      });

      setTimeout(() => {
        _handleSetDataField(CONST.tipo.name, tipoActividadExtra.RECUPERACION);
      }, 300);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    if (!activo) return;

    let values = {};
    Object.keys(data).map((key) => (values[key] = activo[key]));
    setTimeout(
      () =>
        setData({
          ...values,
          idInstrumento: activo.instrumento.id,
          idPtevaInstrumento: activo.ptevaInstrumento.id,
        }),
      300,
    );

    setTimeout(() => {
      setSelectPevaInstrumento(activo.ptevaInstrumento);
    }, 700);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activo]);

  const _handleSetDataField = (key, value) =>
    setData({ ...data, [key]: value });

  const _validDataForm = () => {
    let r = {};
    let va = [];
    Object.keys(dataError).map((key) => {
      const val = data[key];
      const valid = !val || val === '' || val === 0;
      r[key] = valid;
      return va.push(valid);
    });
    setDataRequired(r);
    return !va.includes(true);
  };

  const _handleSubmit = async () => {
    if (!planEvaluacionStore.activo) {
      notify('Falta seleccionar un plan de evaluación', { warning: true });
      return;
    }
    if (_validDataForm()) {
      setLoadingSave(true);
      let res = await saveActividadesExtrasAction(
        { dispatch, notify },
        activo?.id,
        {
          ...data,
          idPtevaInstrumento: selectPevaInstrumento?.id,
          idPlanEvaluacion: planEvaluacionStore.activo.id,
        },
        actividadesExtrasStore.params,
      );
      if (res && !activo) setOpenModalForm(false);
      setLoadingSave(false);
    }
  };

  React.useEffect(() => {
    _handleSetDataField(CONST.ponderacion.name, '');

    if (
      selectPevaInstrumento &&
      data.tipo === tipoActividadExtra.RECUPERACION
    ) {
      _handleSetDataField(
        CONST.ponderacion.name,
        selectPevaInstrumento.ponderacion,
      );
    } else {
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectPevaInstrumento]);

  // React.useEffect(() => {
  //   _handleSetDataField(CONST.instrumento.idName, '');

  //   if (data.tipo === tipoActividadExtra.REMEDIAL) {
  //     setInstrumentos([]);
  //     _handleSetDataField(CONST.ponderacion.name, '');
  //     return;
  //   }

  //   const array = [];
  //   pevaInstrumentos.forEach((pevaInstrumento) =>
  //     array.push(pevaInstrumento.instrumento),
  //   );
  //   setInstrumentos(array);

  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [data.tipo]);

  return (
    <Box component="form">
      <Grid container spacing={2}>
        {loadingSave && (
          <Grid item xs={12} md={12}>
            <LoadingWidget isLoading={loadingSave} isActivo={activo} />
          </Grid>
        )}

        <Grid item xs={12} md={6}>
          <FormControl fullWidth size="small">
            <InputLabel id={`label_${CONST.tipo.name}`}>
              Tipo de actividad
            </InputLabel>
            <Select
              id={CONST.tipo.name}
              value={data.tipo}
              required
              labelId={`label_${CONST.tipo.name}`}
              label="Activar fecha"
              onChange={(e) =>
                _handleSetDataField(CONST.tipo.name, e.target.value)
              }
            >
              <MenuItem value={tipoActividadExtra.RECUPERACION}>
                {tipoActividadExtra.RECUPERACION}
              </MenuItem>
              <MenuItem value={tipoActividadExtra.REMEDIAL}>
                {tipoActividadExtra.REMEDIAL}
              </MenuItem>
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} md={6}>
          <SelectFieldActividadesAcademicasComponent
            id="selectActividades"
            value={data.idInstrumento}
            isEmpty={false}
            required
            label="Instrumento a evaluar"
            onChange={(idInstrumento) => {
              _handleSetDataField(CONST.instrumento.idName, idInstrumento);
            }}
            error={dataError.idInstrumento}
          />
        </Grid>

        {data.tipo === tipoActividadExtra.RECUPERACION && (
          <Grid item xs={12} md={6}>
            <SelectFieldActividadesAcademicasComponent
              id="selectActividades"
              value={selectPevaInstrumento?.instrumento.id ?? ''}
              isEmpty={false}
              data={instrumentos}
              label="Actividad a remplazar"
              disabled={data.tipo === tipoActividadExtra.RECUPERACION}
              required={data.tipo === tipoActividadExtra.RECUPERACION}
              onChange={(idInstrumento) => {
                const pevaInstrumento = pevaInstrumentos.find(
                  (pevaInstrumento) =>
                    pevaInstrumento.instrumento.id === idInstrumento,
                );
                setSelectPevaInstrumento(pevaInstrumento);
              }}
              error={
                data.tipo === tipoActividadExtra.REMEDIAL
                  ? null
                  : data.idPtevaInstrumento === ''
              }
            />
          </Grid>
        )}

        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            size="small"
            id={CONST.ponderacion.name}
            required
            disabled={data.tipo === tipoActividadExtra.RECUPERACION}
            label={CONST.ponderacion.label}
            value={data.ponderacion}
            autoComplete="off"
            onChange={(e) => {
              let value = e.target.value;
              _handleSetDataField(CONST.ponderacion.name, value);
            }}
            helperText={dataError.ponderacion ? validMessage.required : null}
            error={dataError.ponderacion}
            type="number"
            InputProps={{
              inputProps: { min: 1, max: 20 },
            }}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <FechaField
            label="Fecha de inicio"
            error={dataError.fechaInicio}
            value={data.fechaInicio ?? ''}
            botonCurrentDate={false}
            onChange={(e) => {
              _handleSetDataField(CONST.fechaInicio.name, dateformat(e, {}));
            }}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            size="small"
            id={CONST.desc.name}
            label={CONST.desc.label}
            value={data.desc}
            multiline
            rows={3}
            onChange={(e) =>
              _handleSetDataField(CONST.desc.name, e.target.value)
            }
          />
        </Grid>

        <Grid item xs={12} md={12} align="center">
          <BotonComponent
            click={_handleSubmit}
            disabled={loadingSave}
            text={activo ? 'ACTUALIZAR' : 'GUARDAR'}
            green={!activo}
            blue={activo}
            saveIcon
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default FormActividadesExtras;
